"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const buttonColor = {
  blue: "blueBg",
  gradient: "gradientBg",
  black: "blackBg",
  transparent: "transparentBg",
  transparentBlueBorder: "transparentBlueBorder",
  transparentBlueBorderDisable: "transparentBlueBorderDisable",
  red: "red",
  redBg: "redBg"
};
const StyledButton = _ref => {
  let {
    disabled,
    onClick,
    type,
    btnType,
    iconClass,
    href,
    newTab,
    btnText,
    ...rest
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    className: (0, _clsx.default)(classes.styledButton, classes[buttonColor[type]]),
    disabled: disabled,
    onClick: onClick,
    type: btnType,
    href: href,
    target: href && newTab ? "_blank" : "",
    rel: href && newTab ? "noopener" : ""
  }, rest), iconClass ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: iconClass
  }) : null, btnText);
};
StyledButton.propTypes = {
  type: _propTypes.default.oneOf(["blue", "gradient", "black", "transparent", "red", "redBg", "transparentBlueBorder", "transparentBlueBorderDisable"]),
  btnType: _propTypes.default.oneOf(["submit", "reset", "button"]),
  btnText: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  iconClass: _propTypes.default.string,
  href: _propTypes.default.string,
  newTab: _propTypes.default.bool
};
StyledButton.defaultProps = {
  type: "blue",
  btnType: "button"
};
var _default = exports.default = StyledButton;